import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';

console.log('System ENV: ', process.env.NODE_ENV);
console.log('PUBLIC_URL: ', process.env.PUBLIC_URL);

const renderApp = () => {
  const containerId = 'privacy-clarity-app';
  const root = ReactDOM.createRoot(document.getElementById(containerId));

  console.log("root: ", root);

  root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
  );
};

window.onload = renderApp;